export const maskMoney = (money: string | number) => {
  if (isNaN(Number(money))) return 0;
  let val: string;
	val = money.toString().replace(/\D/g, '');
	val = val.replace(/(\d)(\d{2})$/, '$1,$2');
	val = val.replace(/(?=(\d{3})+(\D))\B/g, '.');
	return val;
};
